import { FeatureFlag } from '../FeatureFlag';

export const autoCreateAlertsFromChannel = new FeatureFlag({
    key: 'auto-create-alerts-from-channel',
    createdOn: '2025-12-26',
    defaultValue: false,
});
